import { EditorInput } from '../EditorInput';
import { customizeCraftJsComponent } from '../../helpers';

export const EditorFirstNameInput = customizeCraftJsComponent(EditorInput, {
	name: 'First Name Input',
	props: {
		name: 'firstName',
		type: 'text',
		placeholder: 'First Name',
		label: 'First Name'
	}
});
